import { BasePage } from '@/components/ui/base-page'

export function PortalPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add PortalPage specific content here */}
    </BasePage>
  )
}